import React from "react";
import { getAwsAssets } from "@src/utils";
import styles from "../../../styles/DownloadProgressIcon.module.scss";
import { Image } from "@src/components/Image";
import { t } from "i18next";

const DownloadProgressIcon = ({
  progress = 0,
  onClick = null,
  withoutIcon = null,
  startAngle = 0,
  isTextVisible = false,
}) => {
  // HANDLE ICON CLICKED
  const handleIconClicked = (e) => {
    e.stopPropagation();
    onClick && onClick();
  };

  return (
    <div
      className={`${styles.downloadProgressIcon} ${
        isTextVisible ? styles.downloadProgressIconwithText : ""
      }`}
    >
      <div
        className={styles.downloadProgressIcon__icon}
        onClick={handleIconClicked}
        style={{
          "--progressDeg": `${(parseInt(progress) || 0) * 3.6}deg`,
          ...(startAngle ? { transform: `rotate(${startAngle}deg)` } : {}),
        }}
      >
        <div className={styles.downloadProgressIcon__icon__content}>
          {!withoutIcon && (
            <Image
              src={getAwsAssets("crossIcon.svg", "content")}
              alt="crossIcon"
              height={12}
              width={12}
            />
          )}
        </div>
      </div>
      {isTextVisible ? (
        <span className={styles.downloadProgressIcon__text}>
          {t(
            "components.tabs.content.components.contentList.listItem.downloadProgressText",
            "Downloading"
          )}
        </span>
      ) : null}
    </div>
  );
};

export default DownloadProgressIcon;
